export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8007.c895be2f.jpg";